import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import i18n from 'i18next';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [locale, setLocaleState] = useState(() => {
    return localStorage.getItem('medtrend_lang') || 'en';
  });

  const setLocale = (newLocale) => {
    const code = newLocale.toLowerCase();
    setLocaleState(code);
    localStorage.setItem('medtrend_lang', code);
  };

  useEffect(() => {
    // Set axios header
    axios.defaults.headers.common['Accept-Language'] = locale;

    // Change translation language
    i18n.changeLanguage(locale);

    // Toggle RTL for Arabic
    if (locale === 'ar') {
      document.documentElement.dir = 'rtl';
      document.documentElement.lang = 'ar';
    } else {
      document.documentElement.dir = 'ltr';
      document.documentElement.lang = locale;
    }
  }, [locale]);

  return (
    <LanguageContext.Provider value={{ locale, setLocale }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
